export const NODE_ACTIONS = {
  ANALYZE: { id: 'ANALYZE', icon: 'far fa-magnifying-glass-chart' },
  COPY_OF: { id: 'COPY_OF', icon: 'far fa-copy' },
  CONVERT_TO_PDF: { id: 'CONVERT_TO_PDF', icon: 'far fa-file-pdf' },
  DEADLINE: { id: 'DEADLINE', icon: 'far fa-calendar-clock' },
  DELETE: { id: 'DELETE', icon: 'far fa-trash' },
  DELETE_PERMANENTLY: { id: 'DELETE_PERMANENTLY', icon: 'far fa-trash-xmark' },
  DETAILS: { id: 'DETAILS', icon: 'far fa-circle-info' },
  DOWNLOAD: { id: 'DOWNLOAD', icon: 'far fa-download' },
  EDIT: { id: 'EDIT', icon: 'far fa-file-pen' },
  DEEP_FLOW_START: {
    id: 'DEEP_FLOW_START',
    deepIcon: {
      name: 'deep-flow',
    },
  },
  MOVE: {
    id: 'MOVE',
    icon: 'far fa-folder-arrow-right',
  },
  HIDDEN: {
    id: 'HIDDEN',
  },
  RENAME: { id: 'RENAME', icon: 'far fa-pencil' },
  RESTORE: { id: 'RESTORE', icon: 'far fa-clock-rotate-left' },
  SHARE: { id: 'SHARE', icon: 'far fa-link-horizontal' },
  SIGN: { id: 'SIGN' },
  DEEP_A_SUMMARIZATION: {
    id: 'DEEP_A_SUMMARIZATION',
    deepIcon: {
      name: 'deep-a',
    },
  },
  TAG: { id: 'TAG', icon: 'far fa-tag' },
  DEEP_PAY_PAY: {
    id: 'DEEP_PAY_PAY',
    deepIcon: {
      name: 'deep-pay',
    },
  },
  DEEP_MAIL_SEND: {
    id: 'DEEP_MAIL_SEND',
    deepIcon: {
      name: 'deep-mail',
    },
  },
  PDF_COMPARE: {
    id: 'PDF_COMPARE',
    icon: 'far fa-code-compare',
  },
  DEEP_VALIDATOR_OPEN: {
    id: 'DEEP_VALIDATOR_OPEN',
    deepIcon: {
      name: 'deep-validator',
    },
  },
}
